<template>
  <div >
    <el-form :model="ruleForm" class="formpanel" status-icon :rules="rules" ref="ruleForm" label-width="100px">
      <el-form-item label="密码" prop="pass">
        <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="重复密码" prop="checkPass">
        <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div style="display: flex;flex-flow: row;justify-content: flex-end;">
      <el-button class="formpanelbtn" type="primary" icon="el-icon-edit" @click="submitForm('ruleForm')">变更密码</el-button>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'CReSetPW',
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        yzmabled: false,
        ruleForm: {
          pass: '',
          checkPass: ''
        },
        rules: {
          pass: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ]
        }
      };
    },
    mounted: function () {
      that = this
      /* 获取是否通过手机验证 */
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var adata = {
              id: {Int64: parseInt(localStorage.getItem('accountid')), Valid: true},
              password: this.ruleForm.pass
            }
            that.$http({
              url: 'https://api.sqnetsoft.cn/account/changepwd',
              method: 'post',
              data: adata,
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  that.$message({
                    type: 'success',
                    message: '变更成功!'
                  })
                  var systme = 2
                  let interval = window.setInterval(function() {
                    --systme;
                    if (systme < 0) {
                      that.$router.push({path: '/'})
                      window.clearInterval(interval);
                    }
                  }, 1000);
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          } else {
            return false;
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/regedit/CReSetPW.vue